const {KitModule, registerModule} = window;

class FilteredPostGrid extends KitModule {
  constructor($element) {
    super($element);
    // elements
    this.$cards = [...this.$element.querySelectorAll('.card2')];
    // properties
    this.filterKey = this.$element.getAttribute('data-filter-key');
    // events
    this.$filterList.addEventListener('click', this);
    // initialize
    this.updateFilter();
  }

  onclick(event) {
    const $btn = event.target.closest('.btn');
    if (!$btn) return;

    // do not go to new page, do updateFilter
    event.preventDefault();
    // un-select when selected button clicked
    const href = $btn === this.$selectedButton ? '.' : $btn.href;
    window.history.replaceState({}, '', href);
    this.updateFilter();
  }

  updateFilter() {
    const {search} = window.location;
    const params = new URLSearchParams(search);
    const filterValue = params.get( this.filterKey );
    const filterClass = `card2--${this.filterKey}-${filterValue}`;

    // filter cards
    this.$cards.forEach(($card) => {
      const isFiltered = !filterValue || $card.classList.contains(filterClass);
      $card.style.display = isFiltered ? '' : 'none';
    });

    // update selected button
    if (this.$selectedButton) this.$selectedButton.classList.add('btn--dark');
    this.$selectedButton = search ? this.$filterList.querySelector(`[href="${search}"]`) : null;
    if (this.$selectedButton) this.$selectedButton.classList.remove('btn--dark');
  }
}

registerModule('FilteredPostGrid', FilteredPostGrid);
